import { useBackofficePageTitle } from '@/lib/page-title';
import { PageHeader } from '@/components/shared';
import { UsersListSection } from './components';

export function BackofficeUsersPage() {
  useBackofficePageTitle('Users');

  return (
    <main className="min-h-[320px] bg-white p-6 md:p-8" aria-label="Backoffice main content">
      <div className="flex flex-col gap-5">
        <PageHeader>Users</PageHeader>
        <UsersListSection />
      </div>
    </main>
  );
}
